import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { usePlanPrices } from '../../shared/pricing/use-plan-prices';
import { SITE_ORIGIN } from '../../shared/site-origin';
import { landingFaqQuestions } from './landing-faq';

export const LandingStructuredData = () => {
  const { t } = useTranslation();
  const { locale } = useParams();
  const prices = usePlanPrices();

  const structuredData = JSON.stringify([
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: t('app.name'),
      url: `${SITE_ORIGIN}/`,
      logo: `${SITE_ORIGIN}/favicon.svg`,
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: t('app.name'),
      url: `${SITE_ORIGIN}/${locale}/`,
      inLanguage: locale,
    },
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: landingFaqQuestions.map((question) => ({
        '@type': 'Question',
        name: t(`landing.faq.items.${question}.question`),
        acceptedAnswer: {
          '@type': 'Answer',
          text: t(`landing.faq.items.${question}.answer`, { product: t('app.name'), ...prices }),
        },
      })),
    },
  ]).replace(/</g, '\\u003c');

  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: structuredData }} />;
};
